<template>
  <div class="page">
    <!-- <h3 class="text-h3 mb-4">Reports Dashboard</h3> -->
    <!-- <v-btn @click="onClickNew"><v-icon>mdi-plus</v-icon>New</v-btn> -->
    <v-data-table
      :headers="headers"
      :items="reportWSIs"
      :items-per-page="10"
      item-key="id"
      :sort-by="['created_at']"
      :sort-desc="[true]"
      @click:row="onClickView"
      :options.sync="options"
      :footer-props="footerProps"
      class="table"
    >
      <!-- <template v-slot:[`item.thumbnail`]="{ item }">
        <v-img :src="item.thumbnail"></v-img>
      </template> -->
      <template v-slot:[`item.id`]="{ item }">
        <div>
          {{ item.id }}
        </div>
      </template>
      <template v-slot:[`item.status`]="{ item }">
        <v-chip :color="getStatusColor(item.status)" dark>
          {{ $t("report.reportStatus." + item.status) }}
        </v-chip>
      </template>
      <!-- <template v-slot:[`item.service`]="{ item }">
        <div>
          {{ item.service || formatDate }}
        </div>
      </template> -->
    </v-data-table>
    <!-- <AddDialog v-model="dialog"></AddDialog> -->
  </div>
</template>
<script>
// import AddDialog from "@/components/service/AddDialog";
import { mapGetters } from "vuex";
import { LOAD_DIAGNOSIS } from "@/store/modules/diagnosis";
import {
  TOTAL,
  WSIS,
  LIST,
  LOAD_REPORTBATCHES,
  SET_CURRENT_INDEX_REPORTWSI,
  ACTION_SET_CURRENT_REPORTDIAGNOSIS,
  ACTION_SET_CURRENT_REPORTWSI,
  ACTION_SET_CURRENT_REPORTTILEGRID
} from "@/store/modules/service";

export default {
  data() {
    return {
      dialog: false,
      options: undefined
    };
  },
  computed: {
    ...mapGetters({
      reportBatches: LIST,
      reportWSIs: WSIS,
      total: TOTAL
    }),
    footerProps() {
      return {
        "items-per-page-options": [5, 10, 15],
        "items-per-page-text": this.$t("report.serviceTable.footerText")
      }
    },
    headers() {
      return [
        {
          text: this.$t("report.serviceTable.id"),
          value: "id"
        },
        {
          text: this.$t("report.serviceTable.status"),
          value: "status"
        },
        {
          text: this.$t("report.serviceTable.requestDate"),
          align: "start",
          value: "created_at"
        },
        {
          text: this.$t("report.serviceTable.biopsyID"),
          sortable: "false",
          value: "biopsy_id"
        },
        {
          text: this.$t("report.serviceTable.plaqueID"),
          value: "plaque_id"
        }
      ];
    },
    inProgress() {
      return this.$t("report.reportStatus.notification.in_progress")
    },
    awaitingPayment() {
      return this.$t("report.reportStatus.notification.awaiting_payment")
    },
    failed() {
      return this.$t("report.reportStatus.notification.failed")
    }
  },
  methods: {
    getStatusNotification(status) {
      switch (status) {
        case "in_progress":
          return this.inProgress;
        case "failed":
          return this.failed;
        case "awaiting_payment":
          return this.awaitingPayment;
        default:
          return ":(";
      }
    },
    getStatusColor(status) {
      switch (status) {
        case "waiting_approval":
          return "blue";
        case "approved":
          return "green";
        case "in_progress":
          return "orange";
        case "failed":
          return "red";
        case "awaiting_payment":
          return "orange";
      }
    },
    onClickNew() {
      this.dialog = true;
    },
    async onClickView(item) {
      if (item.status === "waiting_approval") {
        let id = item.id;
        const page = "service-view";
        const index = this.$store.state.service.allIdsReportWSI.indexOf(
          id.toString()
        );
        this.$store.commit(SET_CURRENT_INDEX_REPORTWSI, index);
        this.$store.dispatch(LOAD_DIAGNOSIS);
        this.$store.dispatch(ACTION_SET_CURRENT_REPORTWSI, { id });
        this.$store.dispatch(ACTION_SET_CURRENT_REPORTTILEGRID, { id });
        this.$store.dispatch(ACTION_SET_CURRENT_REPORTDIAGNOSIS, { id });
        this.$router.push({ name: page, params: { id: id }});
      } else {
        this.$notify({
          type: "warning",
          text: this.getStatusNotification(item.status)
        });
      }
    }
  },
  watch: {
    options(newVal, oldVal) {
      if (oldVal) {
        if (
          newVal.itemsPerPage !== oldVal.itemsPerPage ||
          newVal.page !== oldVal.page
        ) {
          this.$store.dispatch(LOAD_REPORTBATCHES, newVal);
        }
      }
    }
  },
  created() {
    this.$store.dispatch(LOAD_REPORTBATCHES, undefined);
  }
};
</script>

<style scoped></style>
